enum DealerAddViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default DealerAddViewMode;
